import { useTranslation } from 'react-i18next';
import { usePriceEntryMode } from '../../hooks/usePriceEntry';

/**
 * The line above a block of price fields saying how they are entered. Prices
 * are always STORED gross (#1353); with net entry on, the fields take net and
 * convert (#2967). Said at the entry point, or the wrong figure gets typed.
 */
const PriceEntryNote = ({ className = 'text-xs text-foreground/60' }: Readonly<{ className?: string }>) => {
    const { t } = useTranslation();
    const mode = usePriceEntryMode();
    return (
        <p className={className}>
            {t(mode === 'net' ? 'price_entry.net_prices_note' : 'common.gross_prices_note')}
        </p>
    );
};

export default PriceEntryNote;
